"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.personShortcut = personShortcut;
exports.default = PettyCashEntryPage;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const react_hook_form_1 = require("react-hook-form");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const yup_1 = require("@hookform/resolvers/yup");
const PostalDispatchSection_1 = __importDefault(require("./PostalDispatchSection"));
const trackingNumber_1 = require("./trackingNumber");
const PettyCashValidationSchema_1 = require("./PettyCashValidationSchema");
const recentValues_1 = require("./recentValues");
const vatAmount_1 = require("./vatAmount");
const SheetPreview_1 = __importDefault(require("./SheetPreview"));
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const vehiclesApi_1 = require("../../Mileage/vehiclesApi");
const fuelNote_1 = require("./fuelNote");
const pettyCashApi_1 = require("./pettyCashApi");
const DocumentScanPanel_1 = __importDefault(require("./DocumentScanPanel"));
const KIND_LABELS = {
    POSTAL: "poczta — listy",
    INVOICE: "zakup z fakturą",
    RECEIPT: "paragon",
    FUEL: "paliwo (tankowanie)",
    NO_DOCUMENT: "wydatek bez dokumentu",
    ADVANCE: "wypłata zaliczki",
};
/** Opis, który wysyłki pocztowe mają w arkuszu od zawsze — podpowiadamy go zamiast kazać pisać. */
const POSTAL_DESCRIPTION = "poczta - listy";
/**
 * Opis wpisu za paliwo bierze się z wybranego auta — "Paliwo Ford Focus OP 8105L".
 * Numer rejestracyjny zostaje w opisie, bo po nim rozlicza się koszt paliwa na pojazd.
 */
const FUEL_DESCRIPTION_PREFIX = "Paliwo ";
const fuelDescription = (vehicle) => `${FUEL_DESCRIPTION_PREFIX}${(0, vehiclesApi_1.vehicleLabel)(vehicle)}`;
const FORM_WIDTH = 640;
/**
 * Odnośnik do arkusza jako przycisk. Adres pochodzi z konfiguracji serwera, więc dopóki
 * nie wróci, przycisk jest nieaktywny zamiast prowadzić donikąd.
 */
function SheetButton({ url, label }) {
    return (react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", size: "sm", href: url ?? undefined, target: "_blank", rel: "noreferrer", disabled: !url, title: url ? "Otwiera arkusz w nowej karcie" : "Adres arkusza nie jest skonfigurowany" },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUpRightFromSquare, className: "me-2" }),
        label));
}
const today = () => new Date().toISOString().slice(0, 10);
/**
 * Skrót osoby w zapisie używanym w arkuszu: pierwsza litera imienia i trzy pierwsze
 * litery nazwiska, wielkimi literami — `Anna Dorosińska` → `ADOR`.
 */
function personShortcut(fullName) {
    const [first = "", second = ""] = fullName.trim().split(/\s+/);
    return (first.slice(0, 1) + second.slice(0, 3)).toUpperCase();
}
/**
 * Domyślnie płaci ten, kto wpisuje. Ostatnio użyta wartość ma pierwszeństwo, bo bywa,
 * że wpisuje się za kogoś.
 */
function defaultPayer() {
    const remembered = (0, recentValues_1.lastUsed)(recentValues_1.RECENT_KEYS.payer);
    if (remembered)
        return remembered;
    try {
        return personShortcut(MainSetupReact_1.default.currentUserOrNull?.userName ?? "");
    }
    catch {
        return "";
    }
}
/**
 * Formularz wpisu do zaliczek.
 *
 * Walidacja jak w pozostałych formularzach aplikacji: `react-hook-form` z resolverem
 * `yup`, komunikat pod polem, przycisk zablokowany dopóki formularz nie jest poprawny.
 * Reguły są odbiciem tych, które backend sprawdza na modelu domenowym — tu chodzi
 * o szybką informację zwrotną, rozstrzyga i tak serwer.
 *
 * Pola idą w jednej kolumnie, bo wpisy powstają na telefonie. Tabela pod spodem pokazuje
 * to samo w układzie arkusza i też pozwala pisać — obie powierzchnie czytają ten sam stan.
 */
function PettyCashEntryPage() {
    const schema = (0, react_1.useMemo)(() => (0, PettyCashValidationSchema_1.makePettyCashValidationSchema)(), []);
    const navigate = (0, react_router_dom_1.useNavigate)();
    // Wejście z kilometrówki: tankowanie już zapisane, tutaj zostaje sam paragon.
    // Data, opis i stan licznika są znane, więc formularz otwiera się wypełniony.
    // Podpowiedź dotyczy jednego wpisu i zużywa się po jego zapisaniu - inaczej kolejne
    // wpisy na tym samym ekranie dalej uchodziłyby za przyszłe z kilometrówki.
    const [fromMileage, setFromMileage] = (0, react_1.useState)((0, react_router_dom_1.useLocation)().state?.fuelFromMileage);
    const { register, handleSubmit, watch, setValue, reset, control, formState: { errors, isValid }, } = (0, react_hook_form_1.useForm)({
        mode: "onChange",
        resolver: (0, yup_1.yupResolver)(schema),
        defaultValues: {
            entryKind: fromMileage ? "FUEL" : "POSTAL",
            entryDate: fromMileage?.entryDate || today(),
            // Opis wpisze się sam, gdy dojedzie lista aut - stąd pusty przy wejściu z kilometrówki.
            description: fromMileage ? "" : POSTAL_DESCRIPTION,
            settlementMethod: fromMileage ? "CARD" : "CASH",
            payerLabel: defaultPayer(),
            note: "",
            vehicleId: fromMileage?.vehicleId ?? "",
            odometerReading: fromMileage?.odometerReading ?? "",
            documentNumber: "",
            netAmount: "",
            grossAmount: "",
            noDocumentAmount: "",
            inflowAmount: "",
            items: [],
        },
    });
    const { replace } = (0, react_hook_form_1.useFieldArray)({ control, name: "items" });
    const [busy, setBusy] = (0, react_1.useState)(false);
    const [serverErrors, setServerErrors] = (0, react_1.useState)([]);
    const [result, setResult] = (0, react_1.useState)(null);
    const [links, setLinks] = (0, react_1.useState)(null);
    /**
     * Pole VAT jest pomocnicze i nie należy do formularza: nie idzie do arkusza ani do backendu.
     * `null` = pokazujemy VAT wynikający z netto i brutto (do sprawdzenia z paragonem);
     * napis = wpisany ręcznie, a wtedy to netto wynika z brutto i VAT.
     */
    const [vatInput, setVatInput] = (0, react_1.useState)(null);
    const [vehicles, setVehicles] = (0, react_1.useState)([]);
    /**
     * Dane tankowania, które właśnie trafiło do zaliczek. Trzymamy je osobno od formularza,
     * bo formularz po zapisie czyści się pod następny wpis, a propozycja ma dotyczyć tego,
     * co poszło do arkusza.
     */
    const [savedFuel, setSavedFuel] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        document.title = "Zaliczki";
    }, []);
    (0, react_1.useEffect)(() => {
        (0, pettyCashApi_1.fetchSheetLinks)()
            .then(setLinks)
            .catch(() => setLinks(null));
    }, []);
    const values = watch();
    const kind = values.entryKind;
    const isPostal = kind === "POSTAL";
    const isAdvance = kind === "ADVANCE";
    const isFuel = kind === "FUEL";
    const hasDocumentAmounts = pettyCashApi_1.KINDS_WITH_DOCUMENT.includes(kind);
    const recentPayers = (0, recentValues_1.recall)(recentValues_1.RECENT_KEYS.payer);
    const vatShown = vatInput ?? (0, vatAmount_1.derivedVat)(values.netAmount, values.grossAmount);
    const vatMessage = vatInput === null ? null : (0, vatAmount_1.vatError)(vatInput, values.grossAmount);
    /**
     * Lista aut przyjeżdża dopiero przy paliwie - poza tym rodzajem nikt jej nie potrzebuje,
     * a trasa czyta stany liczników z arkuszy, więc odpowiada kilka sekund.
     */
    (0, react_1.useEffect)(() => {
        if (!isFuel || vehicles.length)
            return;
        (0, vehiclesApi_1.fetchVehicles)()
            .then(setVehicles)
            .catch(() => setVehicles([]));
    }, [isFuel, vehicles.length]);
    /** Opis chodzi za autem, dopóki jest nasz - tego, co ktoś wpisał sam, nie nadpisujemy. */
    (0, react_1.useEffect)(() => {
        if (!isFuel)
            return;
        const vehicle = vehicles.find((item) => item.id === values.vehicleId);
        const current = values.description.trim();
        if (!vehicle)
            return;
        if (current && !current.startsWith(FUEL_DESCRIPTION_PREFIX))
            return;
        const next = fuelDescription(vehicle);
        if (current !== next)
            setValue("description", next, { shouldValidate: true });
    }, [isFuel, vehicles, values.vehicleId]);
    const changeKind = (next) => {
        setValue("entryKind", next, { shouldValidate: true });
        // Paliwo płaci się zwykle kartą firmową - podpowiadamy, pole zostaje do zmiany.
        const method = next === "ADVANCE" ? "ADVANCE" : next === "FUEL" ? "CARD" : "CASH";
        setValue("settlementMethod", method, { shouldValidate: true });
        // Podpowiedziany opis chodzi za rodzajem w obie strony. Zabieramy go tylko wtedy, gdy
        // to nadal nasz tekst — tego, co ktoś wpisał sam, zmiana rodzaju nie kasuje.
        const description = values.description.trim();
        if (next === "POSTAL" && !description)
            setValue("description", POSTAL_DESCRIPTION, { shouldValidate: true });
        if (next !== "POSTAL" && description === POSTAL_DESCRIPTION)
            setValue("description", "", { shouldValidate: true });
        if (next !== "POSTAL")
            replace([]);
        if (next !== "FUEL") {
            setValue("vehicleId", "", { shouldValidate: true });
            setValue("odometerReading", "", { shouldValidate: true });
        }
        setVatInput(null);
        setResult(null);
        setServerErrors([]);
        setSavedFuel(null);
    };
    /**
     * Podpowiedzi z odczytanego dokumentu. Wypełniamy tylko to, co model faktycznie znalazł —
     * brak wartości zostaje pustym polem, bo puste rzuca się w oczy bardziej niż liczba
     * wzięta z sufitu. Kwoty zapisujemy z przecinkiem, tak jak wpisuje je człowiek i arkusz.
     */
    const applySuggestion = (suggestion) => {
        const amount = (value) => value === null ? null : value.toFixed(2).replace(".", ",");
        const patch = [
            ["documentNumber", suggestion.documentNumber],
            ["grossAmount", amount(suggestion.grossAmount)],
            ["netAmount", amount(suggestion.netAmount)],
        ];
        patch.forEach(([fieldName, value]) => {
            if (value !== null)
                setValue(fieldName, value, { shouldValidate: true, shouldDirty: true });
        });
        // Odczytane netto i brutto mają pokazać VAT do sprawdzenia z dokumentem.
        setVatInput(null);
    };
    const setNet = (net) => setValue("netAmount", net, { shouldValidate: true, shouldDirty: true });
    /**
     * Netto i VAT to para: ostatnio wpisane jest źródłem, drugie wynika z brutto.
     * Wpisanie netto oddaje polu VAT rolę podglądu; zmiana brutto przy wpisanym VAT
     * przelicza netto na nowo.
     */
    const afterAmountChange = (field, value) => {
        if (field === "netAmount")
            setVatInput(null);
        if (field === "grossAmount" && vatInput !== null) {
            const net = (0, vatAmount_1.netFromVat)(value, vatInput);
            if (net !== null)
                setNet(net);
        }
    };
    const changeVat = (vat) => {
        setVatInput(vat);
        const net = (0, vatAmount_1.netFromVat)(values.grossAmount, vat);
        if (net !== null)
            setNet(net);
    };
    /** Tabela edytuje ten sam stan co pola wyżej — jedno źródło prawdy, dwie powierzchnie. */
    const setCashField = (field, value) => {
        setValue(field, value, { shouldValidate: true, shouldDirty: true });
        afterAmountChange(field, value);
    };
    const setItemField = (index, field, value) => {
        setValue(`items.${index}.${field}`, field === "trackingNumber" ? ((0, trackingNumber_1.normalizeTrackingNumber)(value) ?? value) : value, { shouldValidate: true, shouldDirty: true });
        // Numer poprawiony ręcznie przestaje być „ze skanu”, więc zostaje edytowalny.
        if (field === "trackingNumber")
            setValue(`items.${index}.scanned`, false, { shouldDirty: true });
    };
    const buildPayload = (form) => {
        const gross = hasDocumentAmounts ? form.grossAmount : null;
        const expense = kind === "NO_DOCUMENT" ? form.noDocumentAmount : isAdvance ? "0" : form.grossAmount;
        return {
            entryKind: form.entryKind,
            entryDate: form.entryDate,
            description: form.description.trim(),
            // Usługi pocztowe są zwolnione z VAT, więc netto zawsze równa się brutto.
            netAmount: isPostal ? gross : hasDocumentAmounts ? form.netAmount || gross : null,
            grossAmount: gross,
            noDocumentAmount: kind === "NO_DOCUMENT" ? form.noDocumentAmount : null,
            // Przy karcie kolumna wpływu jest lustrem wydatku — liczymy ją, nie pytamy.
            inflowAmount: isAdvance
                ? form.inflowAmount
                : form.settlementMethod === "CARD"
                    ? expense
                    : null,
            documentNumber: form.documentNumber.trim() || null,
            payerLabel: form.payerLabel.trim(),
            settlementMethod: form.settlementMethod,
            // Arkusz ma jedną kolumnę uwagi: przy tankowaniu najpierw licznik, potem uwaga.
            note: (form.entryKind === "FUEL"
                ? (0, fuelNote_1.fuelNote)(form.odometerReading, form.note)
                : form.note.trim()) || null,
            dispatch: isPostal
                ? {
                    invoiceNumber: form.documentNumber.trim(),
                    items: form.items.map((item) => ({
                        trackingNumber: item.trackingNumber,
                        addressee: item.addressee.trim(),
                        contentsDescription: item.contentsDescription.trim() || null,
                        amount: item.amount,
                    })),
                }
                : null,
        };
    };
    const onSubmit = async (form) => {
        setBusy(true);
        setServerErrors([]);
        setResult(null);
        setSavedFuel(null);
        try {
            const commit = await (0, pettyCashApi_1.submitEntry)(buildPayload(form));
            setResult(commit);
            // Z kilometrówki przyszliśmy z gotowym wpisem, więc tam nie odsyłamy.
            if (form.entryKind === "FUEL" && (0, pettyCashApi_1.wroteAnything)(commit) && !fromMileage)
                setSavedFuel({
                    entryDate: form.entryDate,
                    vehicleId: form.vehicleId,
                    odometerReading: form.odometerReading,
                });
            setFromMileage(undefined);
            (0, recentValues_1.remember)(recentValues_1.RECENT_KEYS.payer, form.payerLabel);
            form.items.forEach((item) => {
                (0, recentValues_1.remember)(recentValues_1.RECENT_KEYS.addressee, item.addressee);
                (0, recentValues_1.remember)(recentValues_1.RECENT_KEYS.itemAmount, item.amount);
            });
            reset({
                ...form,
                description: form.entryKind === "POSTAL" ? POSTAL_DESCRIPTION : "",
                documentNumber: "",
                netAmount: "",
                grossAmount: "",
                noDocumentAmount: "",
                inflowAmount: "",
                note: "",
                vehicleId: "",
                odometerReading: "",
                items: [],
            });
            setVatInput(null);
        }
        catch (error) {
            const apiError = error;
            setServerErrors(apiError.errors?.length ? apiError.errors : [apiError.message]);
        }
        finally {
            setBusy(false);
        }
    };
    const field = (name) => ({
        ...register(name),
        isInvalid: Boolean(errors[name]),
    });
    /** Jak `field`, ale zmiana kwoty przelicza też parę netto/VAT. */
    const amountField = (name) => {
        const registered = register(name);
        return {
            ...registered,
            isInvalid: Boolean(errors[name]),
            onChange: (event) => {
                registered.onChange(event);
                afterAmountChange(name, event.target.value);
            },
        };
    };
    const feedback = (name) => (react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, errors[name]?.message));
    const saved = result !== null && (0, pettyCashApi_1.wroteAnything)(result);
    return (react_1.default.createElement(react_bootstrap_1.Container, { style: { maxWidth: 1180 } },
        react_1.default.createElement("div", { style: { maxWidth: FORM_WIDTH }, className: "mx-auto" },
            react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3" },
                react_1.default.createElement("h5", { className: "mb-0" }, "Nowy wpis do zaliczek"),
                react_1.default.createElement("div", { className: "d-flex gap-2" },
                    react_1.default.createElement(SheetButton, { url: links?.pettyCashUrl, label: "Arkusz zaliczek" }),
                    react_1.default.createElement(SheetButton, { url: links?.registerUrl, label: "Rejestr list\u00F3w" }))),
            react_1.default.createElement(react_bootstrap_1.Form, { onSubmit: handleSubmit(onSubmit), noValidate: true },
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Rodzaj"),
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { value: kind, onChange: (event) => changeKind(event.target.value) }, Object.entries(KIND_LABELS).map(([value, label]) => (react_1.default.createElement("option", { key: value, value: value }, label))))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Data"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", ...field("entryDate") }),
                    feedback("entryDate")),
                isFuel && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Samoch\u00F3d"),
                        react_1.default.createElement(react_bootstrap_1.Form.Select, { ...field("vehicleId"), value: values.vehicleId },
                            react_1.default.createElement("option", { value: "" }, vehicles.length === 0
                                ? "Wczytywanie listy aut..."
                                : "Wybierz auto"),
                            vehicles.map((vehicle) => (react_1.default.createElement("option", { key: vehicle.id, value: vehicle.id }, (0, vehiclesApi_1.vehicleLabel)(vehicle))))),
                        feedback("vehicleId")),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Stan licznika"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { inputMode: "numeric", ...field("odometerReading") }),
                        feedback("odometerReading")))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Opis"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { ...field("description") }),
                    feedback("description")),
                hasDocumentAmounts && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(DocumentScanPanel_1.default, { onSuggestion: applySuggestion }),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                        react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, isPostal ? "Numer faktury Poczty" : "Numer dokumentu"),
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { ...field("documentNumber") }),
                        feedback("documentNumber")),
                    react_1.default.createElement("div", { className: "d-flex gap-2 mb-2" },
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "flex-fill" },
                            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, isPostal ? "Kwota faktury" : "Brutto"),
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { inputMode: "decimal", ...amountField("grossAmount") }),
                            feedback("grossAmount")),
                        !isPostal && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "flex-fill" },
                                react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "VAT"),
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { inputMode: "decimal", value: vatShown, onChange: (event) => changeVat(event.target.value), isInvalid: vatMessage !== null, title: "Pole pomocnicze \u2014 nie trafia do arkusza" }),
                                react_1.default.createElement(react_bootstrap_1.Form.Control.Feedback, { type: "invalid" }, vatMessage)),
                            react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "flex-fill" },
                                react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Netto"),
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { inputMode: "decimal", ...amountField("netAmount") }),
                                feedback("netAmount"))))))),
                kind === "NO_DOCUMENT" && (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Kwota (bez dokumentu)"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { inputMode: "decimal", ...field("noDocumentAmount") }),
                    feedback("noDocumentAmount"))),
                isAdvance && (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Przekazana kwota"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { inputMode: "decimal", ...field("inflowAmount") }),
                    feedback("inflowAmount"))),
                !isAdvance && (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Czym zap\u0142acono"),
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { ...register("settlementMethod") },
                        react_1.default.createElement("option", { value: "CASH" }, "got\u00F3wk\u0105 z portfela"),
                        react_1.default.createElement("option", { value: "CARD" }, "kart\u0105 firmow\u0105")))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Kto zap\u0142aci\u0142"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { list: "petty-cash-payers", ...field("payerLabel") }),
                    react_1.default.createElement("datalist", { id: "petty-cash-payers" }, recentPayers.map((value) => (react_1.default.createElement("option", { key: value, value: value })))),
                    feedback("payerLabel")),
                isPostal && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(PostalDispatchSection_1.default, { items: values.items, onChange: (next) => replace(next) }),
                    errors.items && (react_1.default.createElement("div", { className: "text-danger small mb-2" }, errors.items?.message ??
                        "Popraw dane listów — szczegóły przy pozycjach.")))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-1 small text-muted" }, "Uwaga (opcjonalnie)"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { ...field("note") }),
                    feedback("note")))),
        react_1.default.createElement(SheetPreview_1.default, { input: {
                entryKind: kind,
                entryDate: values.entryDate,
                description: values.description,
                netAmount: values.netAmount,
                grossAmount: values.grossAmount,
                noDocumentAmount: values.noDocumentAmount,
                inflowAmount: values.inflowAmount,
                documentNumber: values.documentNumber,
                payerLabel: values.payerLabel,
                settlementMethod: values.settlementMethod,
                note: values.note,
                odometerReading: values.odometerReading,
            }, items: values.items, onCashChange: setCashField, onItemChange: setItemField }),
        react_1.default.createElement("div", { style: { maxWidth: FORM_WIDTH }, className: "mx-auto" },
            serverErrors.length > 0 && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "py-2" }, serverErrors.map((message, index) => (react_1.default.createElement("div", { key: index }, message))))),
            result && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: saved ? "success" : "warning", className: "py-2" },
                saved ? "Zapisano." : "Pominięto — nic nie zostało dopisane.",
                result.register && (react_1.default.createElement("div", { className: "small" },
                    "Rejestr list\u00F3w:",
                    " ",
                    result.register.action === "write"
                        ? `blok ${result.register.blockNumber}, wiersz ${result.register.headerRow}.`
                        : result.register.reason)),
                react_1.default.createElement("div", { className: "small" },
                    "Zaliczki:",
                    " ",
                    result.cash.action === "write"
                        ? `wiersz ${result.cash.targetRow}.`
                        : result.cash.reason))),
            savedFuel && (react_1.default.createElement("div", { className: "d-grid mb-4" },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", size: "lg", onClick: () => navigate(`/mileage/${savedFuel.vehicleId}`, {
                        state: { fuelFromPettyCash: savedFuel },
                    }) }, "Dodaj wpis do kilometr\u00F3wki"),
                react_1.default.createElement("div", { className: "small text-muted mt-1 text-center" }, "Otworzy kilometr\u00F3wk\u0119 z danymi tego tankowania."))),
            react_1.default.createElement("div", { className: "d-grid mb-4" },
                react_1.default.createElement(react_bootstrap_1.Button, { size: "lg", disabled: busy || !isValid, onClick: handleSubmit(onSubmit) }, busy ? react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border" }) : "Zatwierdź")))));
}
